import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=4a3e91cc&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=4a3e91cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e91cc",
  null
  
)

export default component.exports